import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";

const json = {
  2: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P21-E3",
    audio: "Audios/bt_fpt_ai/p15_e2.mp3",
    video: "",
    // isTuLuan:true,
    // isEssay:true,
    autoPlay: "true",
    // recorder: true,
    exerciseKey: "",
    component: Circle_Write,
    // hideBtnFooter: true,
    // inputSize: 110,
    // textAlign: "left",
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em kích chuột vào ô trống đứng trước nội dung em muốn sửa và gõ chữ vào mỗi dòng để ghi lại phần sửa của em.
        <div><video src="Audios/bt_fpt_ai/guide/p15_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "2.",
        title: `
        <div style='font-size:25px;color:rgb(102 96 132)'>
				Đọc soát và chỉnh sửa bài viết.
				</div>
				`,
        color: "rgb(3, 103, 181)",
      },
    ],
    isHello:true,
    textareaStyle: {
      // background: 'none',
      width: 800,
      fontSize: 24,
      paddingTop: 5,
    },
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 11,
        inputStyle: {
          width: 900,
          fontSize: 24,
          textAlign: "left",
          // borderBottom: "1px solid gray",
        },
        answers: ["helo"],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 10,
          // border: "2px solid black",
          // borderRadius: "50%",
          width: "40px",
          height: "40px",
          marginBottom: "10px",
          color: "transparent",
          fontWeight: "bold",
          // borderColor: "transparent",
        },
        selectWordStyle: {
          padding: 10,
          // border: "2px solid black",
          color: "black",
          // borderColor: '#00aeef',
        },
        limitSelect: 5,
        listWords: [
          `✓  ✓  ✓  ✓  ✓`, //1
        ],
        answers: [""],
        initialValue: [],
      },
      Layout: `

		- Đánh dấu ✓ vào ô trống trước nội dung em muốn sửa trong bài làm của mình.
    <div style='display:flex;width:20cm;position:relative'>
      <div style='display:flex;position:absolute; flex-direction:column;top:-4px;left:5px'><input id='0' type='Circle'></div>
      <div style='display:flex; flex-direction:column;width:13mm'>
            <span style='color:transparent;border:2px solid black; border-radius:10px; padding:2px 6px;text-align:center'>.</span>
            <span style='margin:5px 0px;color:transparent;border:2px solid black; border-radius:10px; padding:2px 6px;text-align:center'>.</span>
            <span style='color:transparent;border:2px solid black; border-radius:10px; padding:2px 6px;text-align:center'>.</span>
            <span style='margin:5px 0px;color:transparent;border:2px solid black; border-radius:10px; padding:2px 6px;text-align:center'>.</span>
            <span style='color:transparent;border:2px solid black; border-radius:10px; padding:2px 6px;text-align:center'>.</span>
        </div>
  		  <div style='margin-left:20px;line-height:50px'>
					Cách mở đoạn<br>
					Cách kết thúc<br>
					Cách thức trình bày đoạn văn<br>
					Cách trình bày lí do<br>
					Cách dùng từ, đặt câu<br>
				</div>
        
  	</div>
			<div>
			  - Ghi lại phần sửa của em:
			  <textarea id='0' rows='6'></textarea>
			</div>

  		`,
    },
  },

  // 1: {
  //   unit: "Unit Starter",
  //   id: "FP8-WB-demo-2023-US-P5-E1",
  //   audio: "Audios/bt_fpt_ai/p15_e1_1.mp3",
  //   video: "",
  //   autoPlay: "true",
  //   recorder: true,
  //   exerciseKey: "/img/FriendsPlus/Page15/Key/E1answerKey.png",
  //   component: T6,
  //   // textAlign: "center",
  //   hideBtnFooter: true,
  //   // maxLength: 1,
  //   inputSize: 81,
  //   stylesTextInput: { fontSize: "22px", height: 29 },
  //   textareaStyle: { width: 700 },
  //   titleQuestion: [
  //     {
  //       num: "1.",
  //       title: `
  //       <div style='font-size:25px;'>
  // 		Đọc câu chuyện về những người có năng khiếu nổi bật và viết thông tin vào phiếu đọc sách.
  // 			</div>
  // 			`,
  //       color: "rgb(3, 103, 181)",
  //     },
  //   ],

  //   questionImage: [],
  //   // hideBtnFooter: true,
  //   isHiddenCheck: true,
  //   isEssay: true,
  //   questions: [
  //     {
  //       title: `
  //       <div style='position: relative; '>
  //           <table style="border-collapse: collapse;">
  //               <tr style="text-align: center; background-color: rgb(55,183,236); border: 2px solid black; display: table-caption;">
  //                 PHIẾU ĐỌC SÁCH
  //               </tr>
  //               <tr style="">
  //                 <td style="border: 2px solid black; padding-left: 15px; padding: 10px;"><div>Tên câu chuyện:</div> <input id='0' width='350px'></input></td>
  //                 <td style=" border: 2px solid black;  padding-left: 15px;">Tác giả: <input id='1' width='300px'></input></td>
  //                 <td style="width:8cm;border: 2px solid black; padding-left: 15px;">Ngày đọc: <input id='2' width='300px'></input></td>
  //               </tr>
  //               <tr style="border: 2px solid black; padding-left: 15px; padding: 10px;">
  //                 Tên nhân vật:<br> <textarea id='0' rows='2'>
  //               </tr>
  //               <tr style="border: 2px solid black; padding-left: 15px; padding: 10px;">
  //                 <span>Năng khiếu nổi bậc của nhân vật:</span> <br>
  //                 <textarea id='1' rows='3'>
  //               </tr>
  //               <tr style="border: 2px solid black; padding-left: 15px; padding: 10px;">
  //                 Mức độ yêu thích: ☆ ☆ ☆ ☆ ☆
  //               </tr>
  //           </table>

  //         </div>

  //         </div>
  //       `,
  //       answer: [""],
  //     },
  //   ],
  // },

  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p15_e1_1.mp3",
    video: "",
    autoPlay: "true",
    // recorder: true,
    isTuLuan:true,
    exerciseKey: "/img/FriendsPlus/Page15/Key/E1answerKey.png",
    component: T6,
    // textAlign: "center",
    // hideBtnFooter: true,
    // maxLength: 1,
    inputSize: 81,
    stylesTextInput: { fontSize: "21px", height: 29, },
    textareaStyle: { width: 1100,paddingTop: 5 },
    titleQuestion: [
      {
        num: "1.",
        title: `
        <div style='font-size:25px;'>
			Đọc câu chuyện về những người có năng khiếu nổi bật và viết thông tin vào phiếu đọc sách.
				</div>
				`,
        color: "rgb(3, 103, 181)",
      },
    ],
    RateStar:
      { 
        countStar:5,
        defaultValue:0,
        style:{
          display:'flex',
          justifyContent:'center',
          marginTop:"-115px",
          marginLeft:"220px",
        },
        styleColor:{
          fontSize:40,
          height:"70px",
        },
        styleFonts:{
          fontWeight:"bold",
          marginTop:10,
          marginLeft:20,
          fontSize:30,
          
        }
      },
    // selectStyle: {
    //   height: 35,
    //   width: 35,
    //   textAlign: "center",
    // },
    // selectOptionRandom: true,
    // selectOptionValues: ["1", "2", "3", "4", "5"],
    questionImage: [],
    isHiddenCheck: true,
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em tìm đọc câu chuyện theo yêu cầu của đề bài và gõ chữ vào mỗi dòng ở từng ô thích hợp trong phiếu đọc sách.
        <div><video src="Audios/bt_fpt_ai/guide/p15_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // isEssay: true,
    questions: [
      {
        title: `
        <div style='position: relative; display: flex; flex-direction: column; width: max-content'>
        <div style="text-align: center; background-color: rgb(55,183,236); border: 2px solid black; display: table-caption; color: rgb(230,249,253); font-weight: 700">
        PHIẾU ĐỌC SÁCH
        </div>
        <div style='display: flex'>
          <div style="border-left: 2px solid black; border-right: 2px solid black; padding-left: 15px;  padding: 10px"><div>Tên câu chuyện:</div> <input id='0' width='600px'></input></div>
          <div style="padding-left: 15px;  padding: 10px">Tác giả:<br> <input id='1' width='250px'></input></div>
          <div style="border-right: 2px solid black; border-left: 2px solid black;  padding-left: 15px;  padding: 10px">Ngày đọc:<br> <input id='2' width='200px'></input></div>

        </div>     
        <div style="border: 2px solid black; padding-left: 15px; padding: 10px;">
          Tên nhân vật:<br> <textarea id='3' rows='2'>
        </div>
        <div style="border: 2px solid black; border-top:none; padding-left: 15px; padding: 10px;">
          <span>Năng khiếu nổi bậc của nhân vật:</span> <br>
          <textarea id='4' rows='3'></textarea>
        </div>
        <div style="border: 2px solid black; border-top:none;  padding-left: 15px; padding: 10px; display: flex">
        Mức độ yêu thích: &ensp;
        
        </div>
          
        </div>
        `,
        answer: ["", "", "", "", "", ""],
      },
    ],
  },
};

export default json;
